
import React, { FC } from "react";

export const IntegrationSuccess: FC = () => {
    return (
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
            <h1>Success!</h1>
            <p>You can close this window now.</p>
        </div>
    );
}